import React, { useState } from 'react';
import axios from 'axios';
import { Star, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } });

// "Ask for review" on a patient record: texts the review link right away.
export const AskReviewButton = ({ patientId, toast }) => {
  const [busy, setBusy] = useState(false);
  const ask = async (force = false) => {
    setBusy(true);
    try {
      await axios.post(`${API}/api/reviews/ask/${patientId}`, { force }, auth());
      toast({ title: 'Review request sent', description: 'The patient got a text asking how their visit went.' });
    } catch (e) {
      const msg = e.response?.data?.detail || 'Could not send the review request';
      if (e.response?.status === 409 && window.confirm(msg)) return ask(true);
      if (e.response?.status !== 409) toast({ title: 'Not sent', description: msg, variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      data-testid="ask-review-button"
      onClick={() => ask(false)}
      disabled={busy}
      className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-amber-700 bg-amber-50 hover:bg-amber-100 border border-amber-200 rounded-lg transition-colors disabled:opacity-60"
      title="Text this patient a quick feedback link with your Google review button"
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Star className="h-3.5 w-3.5" />}
      Ask for review
    </button>
  );
};
